import React from "react";
import './WelcomePage.css';
import { useNavigate } from "react-router-dom";
import BlueVeliaBtn from "../blueveliaBtn/BlueVeliaBtn";

function WelcomePage() {
    const navigate = useNavigate();


    const handleButtonClick = () => {
        navigate("/contact");
    };

    return (
        <div className="dvh-100">

            <div className="hero-row">

                {/* LEFT TEXT */}
                <div className="hero-text">

                    <h1>
                        <span className="font-islands">Bienvenue </span>

                        <span className="font-inter">
                            dans mon Portfolio.
                            <img id="icon-terminal" src="/images/Code.svg" alt="Terminal"
                            />
                        </span>
                    </h1>

                    <p className="intro-text">
                        <strong>Développeur Full Stack</strong> passionné & minutieux, déterminé à devenir un atout précieux
                        pour vos projets. Ce site web présente mes compétences ainsi que mes connaissances en web et en développement logiciel.
                        Jetez-y un œil!
                        <br /><br />
                        D'ailleurs, je vous invite à découvrir <strong style={{ color: "#5985D2" }}>BlueVelia</strong>, mon service de création de sites web modernes et performants.
                    </p>

                    <div className="hero__cta">
                        <BlueVeliaBtn/>

                        <div className="cta-group">
                            <button className="btn-custom" onClick={handleButtonClick}>
                                Écrivez-moi!
                            </button>

                            <img className="image-sparkle" src="/images/Sparkle.svg" alt="Sparkle" />
                        </div>
                    </div>
                    
                </div>

                {/* RIGHT IMAGES */}
                <div className="photo-container">

                    <img className="photo photo-1" src="/images/ImageDeigner.png" alt="Designer" />
                    <img className="photo photo-2" src="/images/Ordinateur_portable_biscuit.png" alt="Laptop" />
                    <img className="photo photo-3" src="/images/Image_chaise.png" alt="Chaise" />

                </div>

            </div>

            <div className="row-icon-next">
                <img className="image-icon_next" src="/images/Caret_Square_Down.svg" alt="Icon_Next" />
            </div>

        </div>
    );
}

export default WelcomePage;